import ErrorDisplay from "./error-display.component";

interface ErrorBoundaryFallbackProps {
  readonly datadogSessionId?: string;
  readonly error?: Error;
  readonly errorDetails?: string;
  readonly routeName?: string;
}

export default function ErrorBoundaryFallback({
  datadogSessionId,
  error,
  errorDetails,
  routeName
}: ErrorBoundaryFallbackProps) {
  return (
    <ErrorDisplay
      error={error}
      errorDetails={errorDetails}
      sessionId={datadogSessionId}
      routeName={routeName}
      isCentered={true}
      showReloadButton={true}
    />
  );
}
